// extracted by mini-css-extract-plugin
module.exports = {"field":"InquiryForm_field__3pkyF","checkbox":"InquiryForm_checkbox__2Rg4Y"};